import React, { useMemo } from 'react'
import Carousel from '../common/Carousel'
import MediaRow from '../common/MediaRow'
import { MediaRowFieldsFragment, useHomeQuery } from '../graphql'
import LoadingScreen from '../common/LoadingScreen'
import LoadingIndicator from '../common/LoadingIndicator'
import { useLazyLoadMediaRows } from '../utils/hooks/useLazyLoadMediaRows'
import { deduplicate } from '../utils/deduplicate'

const Home = () => {
  const take = 5

  const {
    data,
    loading: initLoading,
    fetchMore,
  } = useHomeQuery({
    variables: {
      rowsTake: take,
      rowsSkip: 0,
    },
    fetchPolicy: 'cache-and-network',
  })

  const filteredRows = useMemo(() => {
    const dedupeRows = deduplicate<MediaRowFieldsFragment>(data?.home?.rows || [], (row) => row.id)
    return dedupeRows.filter((row) => row.items.list.length > 0) || []
  }, [data?.home?.rows])

  const { inViewRef, loadingMore } = useLazyLoadMediaRows('home', data?.home?.rows || [], fetchMore, initLoading, take)

  return (
    <LoadingScreen loading={initLoading && !data}>
      <div className={'homeWrapper'}>
        {data?.home?.featured.length ? <Carousel items={data.home.featured} /> : null}
        <div className={'mediaRowWrapper'} style={{ ...styles.mediaRowWrapper, overflowX: 'hidden' }}>
          {filteredRows.map((row, index) => {
            const isLastRow = index === filteredRows.length - 1
            return (
              <div key={index} ref={isLastRow ? inViewRef : null}>
                <MediaRow {...row} />
              </div>
            )
          })}
          <div style={{ height: 50, marginBottom: 25, marginTop: -25 }}>{loadingMore && <LoadingIndicator />}</div>
        </div>
      </div>
    </LoadingScreen>
  )
}

const styles = {
  mediaRowWrapper: {
    overflow: 'hidden',
    width: '100%',
    marginTop: '44px',
  },
}

export default Home
